import { Input } from '@components/index';

type Props = {
  placeholder?: string;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchInput?: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  defaultValue?: string;
};

export const SearchItems = (props: Props) => {
  const {
    placeholder = 'Search',
    handleSearch,
    searchInput,
    inputRef,
    defaultValue,
  } = props;

  return (
    <Input
      ref={inputRef}
      withSearchIcon={true}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={handleSearch}
      value={searchInput}
      customInputClass="h-5"
      containerClass="mb-1"
    />
  );
};
